import PublicHeader from 'routes/PublicHeader';

import LoginBackground from 'assets/images/login.jpg';
import DropBackground from 'assets/images/drop-background.png';

import Enable2FA from 'screens/SignUp/Enable2FA/Enable2FA';
import { LOCAL_STORAGE } from '@constants';

export default function withEnable2FA(Component) {
  const WithEnable2FAWrapper = function (props) {
    const showEnable2FAScreen =
      localStorage.getItem(LOCAL_STORAGE.SHOW_ENABLE_2FA_SCREEN) === 'true';

    if (!showEnable2FAScreen) {
      return <Component {...props} />;
    }

    return (
      <>
        <PublicHeader />
        <div className="row no-gutters">
          <div className="col-lg-6">
            <img className="img-login-signup" src={LoginBackground} alt="select-provider" />
          </div>
          <div className="col-12 col-lg-6">
            <div
              className="content-background content-background--size-contain"
              style={{ backgroundImage: `url(${DropBackground})` }}
            />
            <div className="col-12 col-sm-10 col-md-8 col-lg-8 offset-sm-1 offset-md-2 offset-lg-2">
              <Enable2FA />
            </div>
          </div>
        </div>
      </>
    );
  };

  return WithEnable2FAWrapper;
}
